// extracted by mini-css-extract-plugin
export var createdDate = "_mh-1";
export var divider = "_mh-2";
export var headerDivider = "_mh-3";
export var messagesCard = "_mh-0";
export var messagesContainer = "_mh-7";
export var messagesContainerWrapper = "_mh-4";
export var pointerCapturingButtonBoxes = "_mh-a";
export var showLeftPanelButton = "_mh-9";
export var showMoreButton = "_mh-c";
export var showMoreButtonContainer = "_mh-b";
export var summaryTitle = "_mh-6";
export var systemMessageCardWrapper = "_mh-d";
export var topButtons = "_mh-8";
export var withPadding = "_mh-5";